import React from 'react'
import { Link, NavLink } from "react-router-dom";

function Portfolio() {
    return (
        <section className='Portfolio'>
            <div className="port1">
                <div className="container">
                    <div className="row d-flex align-items-center" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1300">
                        <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="d-flex gap-3 align-items-center">
                                <hr className='hr3' />
                                <h3 className='heading1 m-0'>Portfolio</h3>
                            </div>
                            <h2>
                                Our Latest Projects
                            </h2>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.
                            </p>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 col-12 d-flex align-items-center justify-content-center">
                            <Link to = "/Project" className="btn_2 " style={{border: '1px solid #FF7627'}} >View All Projects</Link>
                        </div>
                        <hr className='mt-5' />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Portfolio
